import { ArrowDownward, ArrowUpward, Remove } from '@mui/icons-material';
import { Box, Fade, SxProps, Typography } from '@mui/material';
import { Theme } from '@mui/system';
import React from 'react';
import { formattedPercent } from '../utils.ts';
import { TickTo } from './TickTo.tsx';

interface CompareProps {
  value: number;
  compare?: number;
  defaultElem?: React.ReactNode;
  sx?: SxProps<Theme>;
}
export const ComparisonWithDefault: React.FC<CompareProps> = ({
  value,
  compare,
  defaultElem,
  sx = {
    fontWeight: 'bold',
  },
}) => {
  let delta = compare ? (value - compare) / compare : 0;
  let Icon = ArrowUpward;
  if (delta <= 0) {
    Icon = ArrowDownward;
    delta = -delta;
  }

  if (Math.abs(delta) === 0) {
    Icon = Remove;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {defaultElem}
      {Boolean(compare) && Boolean(value) && (
        <Fade in>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Icon color={'inherit'} fontSize={'small'} />
            <Typography color={'inherit'} sx={{ ...sx }}>
              <TickTo
                value={delta}
                formatter={(v) => formattedPercent(Math.abs(v))}
              />
            </Typography>
          </Box>
        </Fade>
      )}
    </Box>
  );
};
